import * as React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Divider from '@mui/material/Divider'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

type WorkRegionListProps = {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  selectedRegions: string[]
  workRegions: WorkRegionsResponseType[]
}

const WorkRegionList: React.FC<WorkRegionListProps> = ({ onChange, selectedRegions, workRegions }) => {
  return (
    <List>
      <Divider />
      {workRegions.map((region) => (
        <ListItem key={region.id} divider>
          <FormControlLabel
            control={<Checkbox id={region.id} onChange={onChange} checked={selectedRegions.includes(region.id)} />}
            label={region.name}
          />
        </ListItem>
      ))}
    </List>
  )
}

export default WorkRegionList
